import { Identity } from './Identity';
import { PublicClientApplication } from '@azure/msal-browser';
import AzureConfigStore from '../config/azureConfigStore';

const storageKey = 'az-b7o4ks';
const storage = sessionStorage;

export class AzureIdentity extends Identity {
  _focusedAccount: null | any;
  _msalApp: any;
  cfg: AzureConfigStore;

  constructor(cfg: AzureConfigStore) {
    super();
    this._focusedAccount = null;
    this.cfg = cfg;
    this._init();
  }

  public initialize() {
    return this._msalApp.initialize();
  }

  isAuthenticated() {
    return this.handleRedirectPromise().then((azAuthnResult: any) => {
      try {
        if (azAuthnResult && azAuthnResult.account) {
          this.setFocusedAccount(azAuthnResult.account);
        }
      } catch (error) {}

      let account = this.getAccount();
      if (account) {
        return this.acquireToken()
          .then(function (response: { accessToken: string | any[] }) {
            return response.accessToken && response.accessToken.length > 0;
          })
          .catch(function (response: any) {
            console.log('error acquiring token', response);
            return false;
          });
      }
      return Promise.resolve(false);
    });
  }

  signIn() {
    return this._msalApp.loginRedirect({
      scopes: ['openid'].concat(this.cfg.getScopes()),
      prompt: 'select_account',
    });
  }

  signOut() {
    let account = this.getAccount();
    if (account) {
      this._focusedAccount = null;
      storage.removeItem(storageKey);
      return this._msalApp.logoutRedirect({ account: account });
    }
  }

  forgotPassword() {
    return Promise.resolve(null);
  }

  hasForgotPassword() {
    return false;
  }

  mfaSetup() {
    return Promise.resolve(null);
  }

  hasMfaSetup() {
    return false;
  }

  accessToken() {
    return this.acquireToken()
      .then((authResult: { accessToken: any }) => {
        return authResult.accessToken;
      })
      .catch((error: any) => {
        console.error('error getting access token', error);
      });
  }

  idToken() {
    return this.acquireToken()
      .then((authResult: { idToken: any }) => {
        return authResult.idToken;
      })
      .catch((error: any) => {
        console.error('error getting id token', error);
      });
  }

  tokens() {
    return this.acquireToken()
      .then((authResult: { accessToken: any; idToken: any }) => {
        if (authResult)
          return {
            accessToken: authResult.accessToken,
            idToken: authResult.idToken,
          };
      })
      .catch((error: any) => {
        console.error('error getting tokens', error);
      });
  }

  displayName() {
    let acct = this.getAccount();
    return Promise.resolve(acct ? acct.name : '');
  }

  handleRedirectPromise() {
    return this._msalApp
      .handleRedirectPromise()
      .then((response: any) => {
        return response;
      })
      .catch((error: { errorMessage: string | string[] }) => {
        console.log('ERROR: ', error);
        // Check for forgot password error
        // Learn more about AAD error codes at https://docs.microsoft.com/en-us/azure/active-directory/develop/reference-aadsts-error-codes
        if (error.errorMessage && error.errorMessage.indexOf('AADB2C90118') > -1) {
          try {
            if (this.cfg.getUseB2c()) {
              return this._msalApp.loginRedirect({ authority: this.cfg.getPolicies().AUTHORITIES.FORGOT_PASSWORD });
            }
          } catch (err) {
            console.log('ERROR: ', err);
          }
        }
      });
  }

  getAccount() {
    if (this._focusedAccount) return this._focusedAccount;

    let account = storage.getItem(storageKey);
    if (account) {
      this._focusedAccount = JSON.parse(account);
      return this._focusedAccount;
    }

    return null;
  }

  getAccounts() {
    return this._msalApp.getAllAccounts();
  }

  setFocusedAccount(account: any) {
    this._focusedAccount = account;
    storage.setItem(storageKey, JSON.stringify(account));
  }

  acquireToken() {
    let account = this.getAccount();
    if (!account) return Promise.resolve(null);

    return this._msalApp.acquireTokenSilent({
      account: account,
      scopes: this.cfg.getScopes().slice(),
      forceRefresh: false,
    });
  }

  _init() {
    if (this.cfg.getUseB2c()) {
      this._msalApp = new PublicClientApplication({
        auth: {
          clientId: this.cfg.getClientId(),
          authority: this.cfg.getPolicies().AUTHORITIES.SIGN_IN,
          knownAuthorities: [this.cfg.getPolicies().AUTHORITY_DOMAIN],
          redirectUri: this.cfg.getRedirectUri(),
        },
        cache: {
          cacheLocation: 'sessionStorage',
          storeAuthStateInCookie: false,
        },
      });
    } else {
      this._msalApp = new PublicClientApplication({
        auth: {
          clientId: this.cfg.getClientId(),
          authority: this.cfg.getPolicies().AUTHORITIES.SIGN_IN,
          redirectUri: this.cfg.getRedirectUri(),
          postLogoutRedirectUri: this.cfg.getRedirectUri(),
        },
        cache: {
          cacheLocation: 'sessionStorage',
          storeAuthStateInCookie: false,
        },
      });
    }
  }
}
